var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

import queryString from 'query-string';
import iframeUtil from './IframeUtil/index';
import postMessageUtil from './PostMessageUtil';
import q from 'q';
import _ from 'lodash';
import jwtHelper from './JwtHelper';

// VARS
var tokens = {};
var nonceValue = '';
var tokensSetDeferred = q.defer();
var tokenRefreshTimer = void 0;
var refreshTimeOffset = 100e3; // 100 seconds prior to token expiration we want to request a new token

var ERRORS = { // Errors which can be used to detect the reason
    notLoggedIn: 'notLoggedIn',
    loginError: 'checkIfLoggedInError',
    fullPageRedirectRequired: 'fullPageRedirectRequired'
};

// METHODS
/**
 * Leaves only guidewire.edge authorities
 *
 * @param {Array} authorities
 * @returns {Array.<String>}
 */
function filterScopeAuthorities(authorities) {
    return authorities.filter(function (authority) {
        return authority.includes('guidewire.edge');
    });
}

function scheduleTokenRefreshReq(oAuthClientId, stateParam, currentToken) {
    var currentTokenExpiryWindowSecs = currentToken.exp - currentToken.iat;
    var currentTokenExpiryWindowMilliSecs = currentTokenExpiryWindowSecs * 1000;
    if (tokenRefreshTimer) {
        window.clearTimeout(tokenRefreshTimer);
    }
    tokenRefreshTimer = window.setTimeout(function () {
        requestAccessToken(oAuthClientId, stateParam);
    }, currentTokenExpiryWindowMilliSecs - refreshTimeOffset);
}

function setTokensFromUrlHash(parsedHash) {
    if (parsedHash.nonce !== nonceValue) {
        throw new Error('nonce value of token does not match the value used in request');
    }
    // if (parsedHash.state !== sessionStorage.oauth_state) {
    //    throw new Error('state value of token does not match the value used in request');
    // }
    tokens.accessToken = parsedHash.access_token;
    var scopeAuthorities = filterScopeAuthorities(parsedHash.scope.split(' '));

    if (!tokens.accessToken && !scopeAuthorities.length) {
        tokensSetDeferred.reject(tokens);
        throw new Error('Expecting to set an access token or authorities or both');
    }
    tokensSetDeferred.resolve(tokens);
    return tokens;
}

function getAuthorizeUrl(oAuthClientId, stateParam) {
    function generateNonce() {
        var nonce = '';
        var nonceLength = 16;
        var possibleChars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        for (var i = 0; i < nonceLength; i++) {
            nonce += possibleChars.charAt(Math.floor(Math.random() * possibleChars.length));
        }
        return nonce;
    }

    nonceValue = generateNonce();

    var params = {
        response_type: 'token',
        client_id: oAuthClientId,
        nonce: nonceValue
    };
    var stateValue = '';
    if (stateParam) {
        stateValue = '|' + stateParam;
    }
    params.state = '' + nonceValue + stateValue;

    var serializedParams = queryString.stringify(params);

    return '/oauth/authorize?' + serializedParams;
}

function requestAccessToken(oAuthClientId, stateParam) {
    var authorizeUrl = getAuthorizeUrl(oAuthClientId, stateParam);
    var deferred = q.defer();
    var LOGIN_POSTMESSAGE_CHANNEL_NAME = 'login-redirect-data'; // used on both login-redirect page as well
    var LOGGED_USER_REDIRECT_URL = 'login-redirect.html'; // expected URL to be redirected when user is logged in

    var loadIframeForTokens = iframeUtil.loadIframe({
        src: authorizeUrl,
        expectedSrcPartOnLoad: LOGGED_USER_REDIRECT_URL
    }).then(function (iframeData) {
        iframeData.clearIframeArtifacts(); // cleaning
        return iframeData;
    });

    var setTokensFromIframe = postMessageUtil.waitForPostMessage(LOGIN_POSTMESSAGE_CHANNEL_NAME).then(function (loginRedirectHash) {
        return setTokensFromUrlHash(queryString.parse(loginRedirectHash));
    });

    // waits till the Auth page is loaded
    // in iframe with possible redirect if user is logged in,
    // which in turn triggers postmessage with tokens,
    // so the promise waits till the postmessage is received as well.
    // After that tokens are assigned
    q.all([loadIframeForTokens, setTokensFromIframe]).then(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
            oAuthToken = _ref2[1];

        deferred.resolve({
            res: oAuthToken
        });
        scheduleTokenRefreshReq(oAuthClientId, stateParam, jwtHelper.decodeToken(oAuthToken.accessToken));
    }, function (err) {
        var resultError = { // default
            error: ERRORS.loginError
        };

        if (err && err.error && err.error === iframeUtil.ERRORS.expectedSrcPartOnLoad) {
            resultError = {
                error: ERRORS.notLoggedIn
            };
        }
        if (err && err.fullPageRedirectRequired) {
            resultError = {
                error: ERRORS.notLoggedIn,
                redirect: err.fullPageRedirectRequired
            };
        }
        deferred.reject(resultError);
    });

    return deferred.promise;
}

function removeTokens() {
    var tokenOrigin = jwtHelper.decodeToken(tokens.accessToken).origin;
    delete tokens.accessToken;
    delete tokens.authorities;
    nonceValue = '';
    tokensSetDeferred = q.defer();
    if (tokenRefreshTimer) {
        window.clearTimeout(tokenRefreshTimer);
    }
    return tokenOrigin;
}

function waitTokensSet() {
    return tokensSetDeferred.promise;
}

// EXPORT
export default (function (_ref3) {
    var clientId = _ref3.clientId,
        refreshRedirectPage = _ref3.refreshRedirectPage;

    return {
        requestAccessToken: _.partial(requestAccessToken, clientId, refreshRedirectPage),
        removeTokens: removeTokens,
        waitTokensSet: waitTokensSet,
        filterScopeAuthorities: filterScopeAuthorities
    };
});


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/api/gw-portals-auth-js/utils/OAuthUtil.js
// module id = 880
// module chunks = 0